import axios from "axios";

export const getPartners = async () => {
  const res = await axios.get("https://alnabaatech.com.ly/api/partners");
  return res.data.data;
};